import "core-js/modules/es.object.keys.js";
import "core-js/modules/es.symbol.js";
import "core-js/modules/es.array.filter.js";
import "core-js/modules/es.object.get-own-property-descriptor.js";
import "core-js/modules/es.array.for-each.js";
import "core-js/modules/web.dom-collections.for-each.js";
import "core-js/modules/es.object.get-own-property-descriptors.js";
import "core-js/modules/es.object.define-properties.js";
import "core-js/modules/es.object.define-property.js";
import "core-js/modules/es.reflect.construct.js";
import "core-js/modules/es.date.to-string.js";
import "core-js/modules/es.object.to-string.js";
import "core-js/modules/es.regexp.to-string.js";
import _regeneratorRuntime from "/home/vsts/work/1/s/dp-components/node_modules/next/node_modules/@babel/runtime/regenerator";
import _slicedToArray from "/home/vsts/work/1/s/dp-components/node_modules/next/node_modules/@babel/runtime/helpers/esm/slicedToArray";
import _asyncToGenerator from "/home/vsts/work/1/s/dp-components/node_modules/next/node_modules/@babel/runtime/helpers/esm/asyncToGenerator";
import _initializerDefineProperty from "/home/vsts/work/1/s/dp-components/node_modules/next/node_modules/@babel/runtime/helpers/esm/initializerDefineProperty";
import _classCallCheck from "/home/vsts/work/1/s/dp-components/node_modules/next/node_modules/@babel/runtime/helpers/esm/classCallCheck";
import _createClass from "/home/vsts/work/1/s/dp-components/node_modules/next/node_modules/@babel/runtime/helpers/esm/createClass";
import _assertThisInitialized from "/home/vsts/work/1/s/dp-components/node_modules/next/node_modules/@babel/runtime/helpers/esm/assertThisInitialized";
import _inherits from "/home/vsts/work/1/s/dp-components/node_modules/next/node_modules/@babel/runtime/helpers/esm/inherits";
import _possibleConstructorReturn from "/home/vsts/work/1/s/dp-components/node_modules/next/node_modules/@babel/runtime/helpers/esm/possibleConstructorReturn";
import _getPrototypeOf from "/home/vsts/work/1/s/dp-components/node_modules/next/node_modules/@babel/runtime/helpers/esm/getPrototypeOf";
import _defineProperty from "/home/vsts/work/1/s/dp-components/node_modules/next/node_modules/@babel/runtime/helpers/esm/defineProperty";
import _applyDecoratedDescriptor from "/home/vsts/work/1/s/dp-components/node_modules/next/node_modules/@babel/runtime/helpers/esm/applyDecoratedDescriptor";

var _class, _descriptor, _descriptor2, _descriptor3;

function ownKeys(object, enumerableOnly) {
  var keys = Object.keys(object);

  if (Object.getOwnPropertySymbols) {
    var symbols = Object.getOwnPropertySymbols(object);
    if (enumerableOnly) symbols = symbols.filter(function (sym) {
      return Object.getOwnPropertyDescriptor(object, sym).enumerable;
    });
    keys.push.apply(keys, symbols);
  }

  return keys;
}

function _objectSpread(target) {
  for (var i = 1; i < arguments.length; i++) {
    var source = arguments[i] != null ? arguments[i] : {};

    if (i % 2) {
      ownKeys(Object(source), true).forEach(function (key) {
        _defineProperty(target, key, source[key]);
      });
    } else if (Object.getOwnPropertyDescriptors) {
      Object.defineProperties(target, Object.getOwnPropertyDescriptors(source));
    } else {
      ownKeys(Object(source)).forEach(function (key) {
        Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
      });
    }
  }

  return target;
}

function _createSuper(Derived) {
  var hasNativeReflectConstruct = _isNativeReflectConstruct();

  return function _createSuperInternal() {
    var Super = _getPrototypeOf(Derived),
        result;

    if (hasNativeReflectConstruct) {
      var NewTarget = _getPrototypeOf(this).constructor;

      result = Reflect.construct(Super, arguments, NewTarget);
    } else {
      result = Super.apply(this, arguments);
    }

    return _possibleConstructorReturn(this, result);
  };
}

function _isNativeReflectConstruct() {
  if (typeof Reflect === "undefined" || !Reflect.construct) return false;
  if (Reflect.construct.sham) return false;
  if (typeof Proxy === "function") return true;

  try {
    Date.prototype.toString.call(Reflect.construct(Date, [], function () {}));
    return true;
  } catch (e) {
    return false;
  }
}

import DPServices from "@dp/services";
import { formatAMPM, getEnvProps, handle, PlatformType, toInteger } from "@dp/common";
import CurbsideModel from "./models/CurbsideModel";
import { action, computed, makeObservable, observable, reaction, runInAction } from "mobx";
import Base from "./Base";
var Curbside = (_class = /*#__PURE__*/function (_Base) {
  _inherits(Curbside, _Base);

  var _super = _createSuper(Curbside); //add all models for curbside here.


  function Curbside(rootStore) {
    var _this$rootStore$user;

    var _this;

    _classCallCheck(this, Curbside);

    _this = _super.call(this);

    _defineProperty(_assertThisInitialized(_this), "rootStore", void 0);

    _initializerDefineProperty(_assertThisInitialized(_this), "curbsideModel", _descriptor, _assertThisInitialized(_this));

    _defineProperty(_assertThisInitialized(_this), "appMessages", null);

    _defineProperty(_assertThisInitialized(_this), "analyticsModel", null);

    _initializerDefineProperty(_assertThisInitialized(_this), "formState", _descriptor2, _assertThisInitialized(_this));

    _initializerDefineProperty(_assertThisInitialized(_this), "_curbsideCheckInTime", _descriptor3, _assertThisInitialized(_this));

    _this.rootStore = rootStore;
    _this.appMessages = rootStore.appMessages;
    _this.curbsideModel = new CurbsideModel(rootStore.appMessages);
    _this.analyticsModel = (_this$rootStore$user = _this.rootStore.user) === null || _this$rootStore$user === void 0 ? void 0 : _this$rootStore$user.analyticsModel;
    makeObservable(_assertThisInitialized(_this));
    return _this;
  }

  _createClass(Curbside, [{
    key: "setupReactions",
    value: function setupReactions() {
      var _this2 = this; //app-init


      reaction(function () {
        return {
          appAttributes: _this2.rootStore.common.appAttributes
        };
      }, function (data) {
        _this2.curbsideModel.setAppAttributesData(data.appAttributes);
      }); // fetch curbside when logged-in state changes
      // not in initial release
      // reaction(
      //   () => {
      //     return { isLoggedIn: this.rootStore?.user?.isLoggedIn };
      //   },
      //   (data) => {
      //     this.fetchCurbsideCheckSummary();
      //   },
      // );
    }
  }, {
    key: "loadCheck",
    value: function () {
      var _loadCheck = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee(tkn) {
        var _getEnvProps, NEXT_PUBLIC_REACT_APP_CHECK_SUMMARY_API_RETRY_COUNT, _yield$handle, _yield$handle2, checkError, checkSummary, _this$curbsideModel, _this$curbsideModel2, _this$curbsideModel3, _this$analyticsModel, _this$curbsideModel4, _this$curbsideModel5, _yield$handle3, _yield$handle4, restaurantError, restaurant;

        return _regeneratorRuntime.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                _context.prev = 0;

                if (!tkn) {
                  _context.next = 31;
                  break;
                }

                _getEnvProps = getEnvProps(), NEXT_PUBLIC_REACT_APP_CHECK_SUMMARY_API_RETRY_COUNT = _getEnvProps.NEXT_PUBLIC_REACT_APP_CHECK_SUMMARY_API_RETRY_COUNT;
                _context.next = 5;
                return handle(DPServices.Curbside.getCheckSummary(tkn, toInteger(NEXT_PUBLIC_REACT_APP_CHECK_SUMMARY_API_RETRY_COUNT, 2)));

              case 5:
                _yield$handle = _context.sent;
                _yield$handle2 = _slicedToArray(_yield$handle, 2);
                checkError = _yield$handle2[0];
                checkSummary = _yield$handle2[1];
                this.curbsideModel.resetModel();

                if (!checkError) {
                  _context.next = 16;
                  break;
                }

                if (this.rootStore.platformUtil.PLATFORM_TYPE === PlatformType.WEB) {
                  this.analyticsModel.setChangeErrorPageNameWithoutRD(true);
                  this.analyticsModel.setPageAnalyticsDetails({
                    pageName: "".concat((_this$curbsideModel = this.curbsideModel) === null || _this$curbsideModel === void 0 ? void 0 : _this$curbsideModel.brandName, "|curbside check in token error page"),
                    pageType: "".concat((_this$curbsideModel2 = this.curbsideModel) === null || _this$curbsideModel2 === void 0 ? void 0 : _this$curbsideModel2.brandName, "|curbside check in token error page")
                  });
                }

                this.curbsideModel.setCheckSummaryData({
                  orderSummary: {
                    orderStatus: "ERROR"
                  }
                });
                this.rootStore.platformUtil.dispatchEvent("AnalyticsEvent", "curbsideLoaded", {
                  checkSummary: "ERROR"
                });
                _context.next = 29;
                break;

              case 16:
                if (checkSummary !== null && checkSummary !== void 0 && checkSummary.orderSummary.checkInDateTime && ((checkSummary === null || checkSummary === void 0 ? void 0 : checkSummary.orderSummary.orderStatus) === "CHECK_CLOSED" || (checkSummary === null || checkSummary === void 0 ? void 0 : checkSummary.orderSummary.orderStatus) === "CLOSED")) {
                  checkSummary.orderSummary.orderStatus = "CHECK_CLOSED";
                } else if (checkSummary !== null && checkSummary !== void 0 && checkSummary.orderSummary.checkInDateTime) {
                  checkSummary.orderSummary.orderStatus = "CHECKED_IN";
                }

                this.rootStore.platformUtil.dispatchEvent("AnalyticsEvent", "curbsideLoaded", {
                  checkSummary: checkSummary.orderSummary.orderStatus
                });
                this.curbsideModel.setCheckSummaryData(checkSummary); // set transaction data into analytics model

                this.analyticsModel.setCurbsideTransaction((_this$curbsideModel3 = this.curbsideModel) === null || _this$curbsideModel3 === void 0 ? void 0 : _this$curbsideModel3.curbsideTransaction);
                this.curbsideModel.curbsideToken = tkn;
                _context.next = 23;
                return handle(DPServices.Curbside.getRestaurantDetailsByNumber(checkSummary.orderSummary.locationNumber));

              case 23:
                _yield$handle3 = _context.sent;
                _yield$handle4 = _slicedToArray(_yield$handle3, 2);
                restaurantError = _yield$handle4[0];
                restaurant = _yield$handle4[1];

                if (restaurantError) {
                  this.curbsideModel.setCheckSummaryData({
                    orderSummary: {
                      orderStatus: "ERROR"
                    }
                  });
                  this.rootStore.platformUtil.dispatchEvent("AnalyticsEvent", "curbsideLoaded", {
                    checkSummary: "Restaurant API ERROR"
                  });
                } else {
                  this.curbsideModel.setRestaurantData(restaurant); // set restaurant detail data into analytic model

                  this.analyticsModel.setRestaurantDetailData(restaurant);
                }

                (_this$analyticsModel = this.analyticsModel) === null || _this$analyticsModel === void 0 ? void 0 : _this$analyticsModel.setPageAnalyticsDetails({
                  pageName: "".concat((_this$curbsideModel4 = this.curbsideModel) === null || _this$curbsideModel4 === void 0 ? void 0 : _this$curbsideModel4.brandName, "|curbside check in page"),
                  pageType: "".concat((_this$curbsideModel5 = this.curbsideModel) === null || _this$curbsideModel5 === void 0 ? void 0 : _this$curbsideModel5.brandName, "|curbside check in page")
                });

              case 29:
                _context.next = 33;
                break;

              case 31:
                this.curbsideModel.setCheckSummaryData({
                  orderSummary: {
                    orderStatus: "ERROR"
                  }
                });
                this.rootStore.platformUtil.dispatchEvent("AnalyticsEvent", "curbsideLoaded", {
                  checkSummary: "ERROR"
                });

              case 33:
                _context.next = 37;
                break;

              case 35:
                _context.prev = 35;
                _context.t0 = _context["catch"](0);

              case 37:
              case "end":
                return _context.stop();
            }
          }
        }, _callee, this, [[0, 35]]);
      }));

      function loadCheck(_x) {
        return _loadCheck.apply(this, arguments);
      }

      return loadCheck;
    }()
  }, {
    key: "checkin",
    value: function () {
      var _checkin = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee2() {
        var isValid, _this$curbsideModel6, payload, channel, _this$curbsideModel$p, _yield$handle5, _yield$handle6, err, checkInResponse, _checkInResponse$head, _this$curbsideModel7, _this$curbsideModel8;

        return _regeneratorRuntime.wrap(function _callee2$(_context2) {
          while (1) {
            switch (_context2.prev = _context2.next) {
              case 0:
                this.analyticsModel.dispatchCurbsideCTAClick({
                  CTAName: "Check in"
                });
                isValid = this.curbsideModel.isCheckinDataValid();

                if (!isValid) {
                  _context2.next = 14;
                  break;
                }

                payload = {
                  orderIDs: {
                    orderID: [{
                      ID: this.curbsideModel.dashOrderID,
                      source: "DASH"
                    }]
                  },
                  corporationID: this.curbsideModel.checkSummary.orderSummary.corporationID,
                  locationNumber: this.curbsideModel.checkSummary.orderSummary.locationNumber,
                  vehicleInformation: {
                    vehicleColor: this.curbsideModel.vehicleColor.toLowerCase(),
                    vehicleType: this.curbsideModel.vehicleType.toLowerCase()
                  }
                };
                channel = this.rootStore.platformUtil.PLATFORM_TYPE === PlatformType.APP ? "MOBILE_APP" : this.rootStore.isMobile ? "MOBILE_WEB" : "DESKTOP";

                if (this.curbsideModel.inputMode === "SIGNAGEINPUT") {
                  payload.ParkingSpot = (_this$curbsideModel$p = this.curbsideModel.parkingSpotValue) === null || _this$curbsideModel$p === void 0 ? void 0 : _this$curbsideModel$p.toString();
                } else if (this.curbsideModel.inputMode === "DESCRIPTIONINPUT") {
                  payload.ParkingDescription = this.curbsideModel.parkingDescription;
                }

                payload.CheckInSource = (_this$curbsideModel6 = this.curbsideModel) === null || _this$curbsideModel6 === void 0 ? void 0 : _this$curbsideModel6.checkInSource;
                _context2.next = 9;
                return handle(DPServices.Curbside.checkIn(payload, channel));

              case 9:
                _yield$handle5 = _context2.sent;
                _yield$handle6 = _slicedToArray(_yield$handle5, 2);
                err = _yield$handle6[0];
                checkInResponse = _yield$handle6[1];

                if (err) {
                  this.rootStore.platformUtil.dispatchEvent("AnalyticsEvent", "curbsideComplete", {
                    checkinSuccess: false,
                    error: err.message
                  });
                  this.dispatchCheckInErrorEvent();
                  this.appMessages.showError("Sorry, something went wrong", err.message, null, {
                    undismissible: false,
                    okBtnText: "Close"
                  });
                } else {
                  this.rootStore.platformUtil.dispatchEvent("AnalyticsEvent", "curbsideComplete", {
                    checkinSuccess: true
                  });
                  this.curbsideCheckInTime = checkInResponse === null || checkInResponse === void 0 ? void 0 : (_checkInResponse$head = checkInResponse["header"]) === null || _checkInResponse$head === void 0 ? void 0 : _checkInResponse$head["timeStamp"]; // set page name and title to success

                  this.analyticsModel.setPageAnalyticsDetails({
                    pageName: "".concat((_this$curbsideModel7 = this.curbsideModel) === null || _this$curbsideModel7 === void 0 ? void 0 : _this$curbsideModel7.brandName, "|curbside checkin success page"),
                    pageType: "".concat((_this$curbsideModel8 = this.curbsideModel) === null || _this$curbsideModel8 === void 0 ? void 0 : _this$curbsideModel8.brandName, "|curbside checkin success page")
                  });
                  this.curbsideModel.updateOrderStatus("JUST_CHECKED_IN");
                }

              case 14:
              case "end":
                return _context2.stop();
            }
          }
        }, _callee2, this);
      }));

      function checkin() {
        return _checkin.apply(this, arguments);
      }

      return checkin;
    }()
    /*  //fetch curbside details
    private async _getCurbsideDetailsOld(tkn) {
      try {
        const curbsideDetails = await DPServices.Curbside.getCheckSummary(tkn);
        //TO DO move rest info call into here later
      } catch (errorObj) {
        const faultCodes = getFaultCodesCheckSummary(errorObj);
        const faultCode =
          faultCodes && faultCodes.length > 0 ? faultCodes[0] : null;
        if (faultCode) {
          switch (faultCode) {
            case "0": {
              //check closed
              this.curbsideModel.checkSummaryTitle =
                "Your order has been picked up!";
              this.curbsideModel.checkSummaryDescription =
                "Enjoy your food. We would love to see you again soon.";
              break;
            }
            case "1": {
              //check cancelled
              this.curbsideModel.checkSummaryTitle = "Your check was cancelled.";
              this.curbsideModel.checkSummaryDescription =
                "Please call the To Go Specialist for further assistance.";
              break;
            }
            case "2": {
              //already checked in
              this.curbsideModel.checkSummaryTitle = "You already checked in.";
              this.curbsideModel.checkSummaryDescription =
                "Your order will arrive shortly.";
              break;
            }
            case "ERROR":
            case "DRI-590":
            case "DRI-100":
            case "DRI-102":
            case "DRI-500":
            case "DRI-501":
            case "DRI-550":
            case "DRI-570":
            case "DRI-590":
            case "DRI-520":
            case "OrderService-606":
            case "OrderService-608": {
              this.curbsideModel.checkSummaryTitle =
                "Oops! Something went wrong.";
              this.curbsideModel.checkSummaryDescription =
                "We were unable to process the information. Please call the To Go Specialist for further assistance.";
              /this.appMessages.showError(
                "Sorry, something went wrong",
                "Your information was unable to be processed, please call and speak to a To Go Specialist for assistance.",
                null,
                {
                  undismissible: false,
                  okBtnText: "Close"
                },
              );/
              break;
            }
          }
        }
      }
       //manually create the getCheckSummary JSON for now
      //TO DO: move into the try above when finished
      //TO DO: check orderStatus here for closed or cancelled checks
      const checkSummary = {
        header: {
          timeStamp: "2021-05-18T19:51:57.09Z",
        },
        orderSummary: {
          orderIDs: {
            orderID: [
              {
                ID: "$Ma$qCwK$0i$3jwK",
                source: "DASH",
              },
              {
                ID: "111442214144",
                source: "DP",
              },
            ],
          },
          corporationID: "012",
          locationNumber: "5461",
          guestName: {
            firstName: "Barani",
            lastName: "Subramanian",
          },
          totalAmount: "11.94",
          tipAmount: "1.19",
          taxAmount: "0.95",
          couponAmount: "0.0",
          isPrepaid: "true",
          orderDateTime: "2021-05-18T11:59:27.133Z",
          pickUpDateTime: "2021-05-18T12:30:00.000Z",
          checkInDateTime: "",
          orderStatus: "CHECK_OPEN",
          vehicleInformation: {
            vehicleColor: "Silver",
            vehicleType: "Van",
          },
          checkNumber: "800196",
        },
      };
      const { orderSummary } = checkSummary,
        locationNumber = orderSummary.locationNumber,
        restaurantId = "2600514";
      if (orderSummary.checkInDateTime !== "") {
        this.curbsideModel.checkSummaryTitle = "You already checked in";
        this.curbsideModel.checkSummaryDescription =
          "Your order will arrive shortly.";
      } else if (orderSummary.orderStatus === "CHECK_CLOSED") {
        this.curbsideModel.checkSummaryTitle = "Your order has been picked up!";
        this.curbsideModel.checkSummaryDescription =
          "Enjoy your food. We would love to see you again soon.";
      } else if (orderSummary.orderStatus === "CHECK_CANCELLED") {
        this.curbsideModel.checkSummaryTitle = "Your check was cancelled.";
        this.curbsideModel.checkSummaryDescription =
          "Please call the To Go Specialist for further assistance.";
      }
      if (restaurantId) {
        const restaurantDetail: RestaurantTypes.RestaurantDetails = await DPServices.Restaurant.getRestaurantDetailsById(
          restaurantId,
        );
        const {
          address,
          restPhoneNumber,
          restaurantName,
          restaurantNum,
          largeImage,
        } = restaurantDetail;
        const phoneNumber = restPhoneNumber[0]; //not safe
        const zipValue = address.zipCode ? address.zipCode.substring(0, 5) : null;
        const curbside: CurbsideDetails = {
          restaurantName: restaurantName,
          restaurantNum: restaurantNum,
          restaurantImg: largeImage.url,
          state: address.state,
          zip: zipValue,
          phoneNumber: formatPhoneNumber(phoneNumber.Phone),
          orderIDs: orderSummary.orderIDs,
          orderStatus: orderSummary.orderStatus,
          totalAmount: (
            +orderSummary.totalAmount + +orderSummary.tipAmount
          ).toFixed(2),
          orderDateTime: orderSummary.orderDateTime,
          pickUpDateTime: orderSummary.pickUpDateTime,
          vehicleType: orderSummary.vehicleInformation.vehicleType,
          vehicleColor: orderSummary.vehicleInformation.vehicleColor,
          numParkingSpots: restaurantDetail.numParkingSpots,
          firstName: orderSummary.guestName.firstName,
        };
        console.log(curbside);
        //this.curbsideModel.curbside = curbside;
      }
    }
    */

  }, {
    key: "init",
    value: function () {
      var _init = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee3() {
        return _regeneratorRuntime.wrap(function _callee3$(_context3) {
          while (1) {
            switch (_context3.prev = _context3.next) {
              case 0:
                this.curbsideModel.setAppAttributesData(this.rootStore.common.appAttributes);
                _context3.next = 3;
                return this.fetchCurbsideCheckSummary();

              case 3:
              case "end":
                return _context3.stop();
            }
          }
        }, _callee3, this);
      }));

      function init() {
        return _init.apply(this, arguments);
      }

      return init;
    }()
  }, {
    key: "refresh",
    value: function () {
      var _refresh = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee4() {
        return _regeneratorRuntime.wrap(function _callee4$(_context4) {
          while (1) {
            switch (_context4.prev = _context4.next) {
              case 0:
              case "end":
                return _context4.stop();
            }
          }
        }, _callee4);
      }));

      function refresh() {
        return _refresh.apply(this, arguments);
      }

      return refresh;
    }()
  }, {
    key: "reset",
    value: function () {
      var _reset = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee5() {
        return _regeneratorRuntime.wrap(function _callee5$(_context5) {
          while (1) {
            switch (_context5.prev = _context5.next) {
              case 0:
              case "end":
                return _context5.stop();
            }
          }
        }, _callee5);
      }));

      function reset() {
        return _reset.apply(this, arguments);
      }

      return reset;
    }()
  }, {
    key: "checkIfCurbsideEnabled",
    value: function () {
      var _checkIfCurbsideEnabled = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee6() {
        var curbsideDetails, token, tokenDetails;
        return _regeneratorRuntime.wrap(function _callee6$(_context6) {
          while (1) {
            switch (_context6.prev = _context6.next) {
              case 0:
                curbsideDetails = {}; // not in initial release
                // const TOKEN_IDENTIFIER =
                //   this.rootStore?.common?.getCurbsideTokenIdentifier();

                _context6.next = 3;
                return this.rootStore.platformUtil.getFromLocalStorage("POS_TOKEN");

              case 3:
                token = _context6.sent;
                tokenDetails = !!token ? JSON.parse(token) : null;

                if (!!tokenDetails) {
                  if (tokenDetails.curbsideEnabled === "true") {
                    curbsideDetails.checkReference = tokenDetails.checkReference;
                    curbsideDetails.enabled = true;
                    curbsideDetails.orderId = tokenDetails.orderId;
                    curbsideDetails.email = tokenDetails.email;
                  }
                }

                return _context6.abrupt("return", curbsideDetails);

              case 7:
              case "end":
                return _context6.stop();
            }
          }
        }, _callee6, this);
      }));

      function checkIfCurbsideEnabled() {
        return _checkIfCurbsideEnabled.apply(this, arguments);
      }

      return checkIfCurbsideEnabled;
    }()
  }, {
    key: "fetchCurbsideOrderSummary",
    value: function () {
      var _fetchCurbsideOrderSummary = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee7(checkReference) {
        var orderDetails;
        return _regeneratorRuntime.wrap(function _callee7$(_context7) {
          while (1) {
            switch (_context7.prev = _context7.next) {
              case 0:
                _context7.next = 2;
                return this.rootStore.platformUtil.getFromLocalStorage(checkReference);

              case 2:
                orderDetails = _context7.sent;
                this.curbsideModel.orderSummary = JSON.parse(orderDetails);

              case 4:
              case "end":
                return _context7.stop();
            }
          }
        }, _callee7, this);
      }));

      function fetchCurbsideOrderSummary(_x2) {
        return _fetchCurbsideOrderSummary.apply(this, arguments);
      }

      return fetchCurbsideOrderSummary;
    }()
  }, {
    key: "fetchCurbsideCheckSummary",
    value: function () {
      var _fetchCurbsideCheckSummary = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee8() {
        var curbsideDetails;
        return _regeneratorRuntime.wrap(function _callee8$(_context8) {
          while (1) {
            switch (_context8.prev = _context8.next) {
              case 0:
                _context8.next = 2;
                return this.checkIfCurbsideEnabled();

              case 2:
                curbsideDetails = _context8.sent;

                if (!curbsideDetails.enabled) {
                  _context8.next = 8;
                  break;
                }

                _context8.next = 6;
                return this.loadCheck(curbsideDetails.checkReference);

              case 6:
                _context8.next = 8;
                return this.fetchCurbsideOrderSummary(curbsideDetails.checkReference)["catch"](function () {
                  return null;
                });

              case 8:
              case "end":
                return _context8.stop();
            }
          }
        }, _callee8, this);
      }));

      function fetchCurbsideCheckSummary() {
        return _fetchCurbsideCheckSummary.apply(this, arguments);
      }

      return fetchCurbsideCheckSummary;
    }()
  }, {
    key: "whenAppActive",
    value: function () {
      var _whenAppActive = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee9() {
        return _regeneratorRuntime.wrap(function _callee9$(_context9) {
          while (1) {
            switch (_context9.prev = _context9.next) {
              case 0:
                _context9.next = 2;
                return this.fetchCurbsideCheckSummary();

              case 2:
              case "end":
                return _context9.stop();
            }
          }
        }, _callee9, this);
      }));

      function whenAppActive() {
        return _whenAppActive.apply(this, arguments);
      }

      return whenAppActive;
    }()
  }, {
    key: "dispatchCurbsideInitialAnalyticsOnMount",
    value: function dispatchCurbsideInitialAnalyticsOnMount() {
      var analyticsFlattenPayload = this.rootStore.platformUtil.flattenObjectWithDot({
        curbside: this.analyticsPayloadWithGeoFenceData
      }, "");
      this.analyticsModel.dispatchCurbsideCheckinEvent("curbside check in page", analyticsFlattenPayload);

      var analyticsPayload = _objectSpread({}, this.analyticsPayloadWithGeoFenceData);

      if (!(this.rootStore.user.foregroundLocationPermissionGranted && this.rootStore.user.backgroundLocationPermissionGranted)) {
        analyticsPayload["geoLocationError"] = "Ask guest to enable geo location";
        analyticsFlattenPayload = this.rootStore.platformUtil.flattenObjectWithDot({
          curbside: analyticsPayload
        }, "");
        this.analyticsModel.dispatchCurbsideCheckinEvent("".concat(this.rootStore.common.appAttributes.concept.conceptCodeDesc, " | location disabled"), analyticsFlattenPayload);
      } else if (!!!analyticsPayload["geofenceCheckinTime"]) {
        analyticsPayload["geoLocationError"] = "Ask guest to check in when they are closer to location";
        analyticsFlattenPayload = this.rootStore.platformUtil.flattenObjectWithDot({
          curbside: analyticsPayload
        }, "");
        this.analyticsModel.dispatchCurbsideCheckinEvent("".concat(this.rootStore.common.appAttributes.concept.conceptCodeDesc, " | location Enabled -outside readius"), analyticsFlattenPayload);
      }
    }
  }, {
    key: "dispatchPushNotificationEnabledEvent",
    value: function dispatchPushNotificationEnabledEvent() {
      this.rootStore.platformUtil.dispatchEvent("AnalyticsEvent", "CurbsideCheckin", {
        pushNotificationEnabled: "true"
      });
    }
  }, {
    key: "dispatchCurbsideCheckinSuccessEvent",
    value: function dispatchCurbsideCheckinSuccessEvent() {
      var _this$curbsideModel$c, _this$curbsideModel$c2, _this$curbsideModel9, _this$curbsideModel10;

      var analyticsPayload = _objectSpread({}, this.analyticsPayloadWithGeoFenceData);

      if (this.curbsideModel.parkingSpotNumberVisible && this.curbsideModel.parkingSpotValue !== null && this.curbsideModel.parkingSpotValue !== undefined && this.curbsideModel.parkingSpotValue > 0) {
        analyticsPayload["spotNumber"] = this.curbsideModel.parkingSpotValue.toString();
      } else if (!!this.curbsideModel.parkingDescription) {
        analyticsPayload["spotNumber"] = this.curbsideModel.parkingDescription;
      }

      analyticsPayload["pickupTime"] = formatAMPM((_this$curbsideModel$c = this.curbsideModel.checkSummary) === null || _this$curbsideModel$c === void 0 ? void 0 : _this$curbsideModel$c.orderSummary.pickUpDateTime);
      analyticsPayload["orderTotal"] = "$".concat((_this$curbsideModel$c2 = this.curbsideModel.checkSummary) === null || _this$curbsideModel$c2 === void 0 ? void 0 : _this$curbsideModel$c2.orderSummary.totalAmount); // set page name and title to success

      this.analyticsModel.setPageAnalyticsDetails({
        pageName: "".concat((_this$curbsideModel9 = this.curbsideModel) === null || _this$curbsideModel9 === void 0 ? void 0 : _this$curbsideModel9.brandName, "|curbside checkin success page"),
        pageType: "".concat((_this$curbsideModel10 = this.curbsideModel) === null || _this$curbsideModel10 === void 0 ? void 0 : _this$curbsideModel10.brandName, "|curbside checkin success page")
      }); // update curbside with success payload

      this.analyticsModel.setCurbsideAnalyticsData(analyticsPayload);
      var analyticsFlattenPayload = this.rootStore.platformUtil.flattenObjectWithDot({
        curbside: analyticsPayload
      }, "");
      this.analyticsModel.dispatchCurbsideCheckinEvent("curbside check in success page", analyticsFlattenPayload);
    }
  }, {
    key: "dispatchCheckInErrorEvent",
    value: function dispatchCheckInErrorEvent() {
      var _this$curbsideModel$c3, _this$curbsideModel11, _this$curbsideModel12;

      var analyticsPayload = _objectSpread({}, this.analyticsPayloadWithGeoFenceData);

      analyticsPayload["spotNumber"] = this.curbsideModel.inputMode === "SIGNAGEINPUT" ? this.curbsideModel.parkingSpotValue.toString() : this.curbsideModel.parkingDescription;
      analyticsPayload["pickupTime"] = formatAMPM((_this$curbsideModel$c3 = this.curbsideModel.checkSummary) === null || _this$curbsideModel$c3 === void 0 ? void 0 : _this$curbsideModel$c3.orderSummary.pickUpDateTime); // set page name and title to failure

      this.analyticsModel.setPageAnalyticsDetails({
        pageName: "".concat((_this$curbsideModel11 = this.curbsideModel) === null || _this$curbsideModel11 === void 0 ? void 0 : _this$curbsideModel11.brandName, "|curbside checkin error page"),
        pageType: "".concat((_this$curbsideModel12 = this.curbsideModel) === null || _this$curbsideModel12 === void 0 ? void 0 : _this$curbsideModel12.brandName, "|curbside checkin error page")
      }); // update curbside with failure payload

      this.analyticsModel.setCurbsideAnalyticsData(analyticsPayload);
      var analyticsFlattenPayload = this.rootStore.platformUtil.flattenObjectWithDot({
        curbside: analyticsPayload
      }, "");
      this.analyticsModel.dispatchCurbsideCheckinErrorEvent("curbside check in error page", analyticsFlattenPayload);
    }
  }, {
    key: "analyticsPayload",
    get: function get() {
      var _this$curbsideModel$r, _this$curbsideModel$c4, _this$curbsideModel13;

      var analyticsPayload = {
        sourceType: this.curbsideModel.checkInSource,
        pushNotificationEnabled: this.rootStore.user.pushNotificationPermissionGranted ? "true" : "false",
        orderId: this.curbsideModel.orderID,
        geoLocationEnabled: (_this$curbsideModel$r = this.curbsideModel.restaurant) !== null && _this$curbsideModel$r !== void 0 && _this$curbsideModel$r.enableGeoFence ? "true" : "false",
        ATGorderId: this.curbsideModel.orderID,
        restaurantNum: (_this$curbsideModel$c4 = this.curbsideModel.checkSummary) === null || _this$curbsideModel$c4 === void 0 ? void 0 : _this$curbsideModel$c4.orderSummary.locationNumber,
        DashOrderId: this === null || this === void 0 ? void 0 : (_this$curbsideModel13 = this.curbsideModel) === null || _this$curbsideModel13 === void 0 ? void 0 : _this$curbsideModel13.dashOrderID,
        orderType: "TOGO"
      };
      return analyticsPayload;
    }
  }, {
    key: "analyticsPayloadWithGeoFenceData",
    get: function get() {
      var analyticsPayload = _objectSpread({}, this.analyticsPayload);

      if (!!this.curbsideCheckInTime) {
        analyticsPayload["geofenceCheckinTime"] = this.curbsideCheckInTime;
      }

      if (!!this.curbsideModel.geoFenceEntryTimestamp) {
        analyticsPayload["geofenceEntryTimeStamp"] = this.curbsideModel.geoFenceEntryTimestamp;
      }

      return analyticsPayload;
    }
  }, {
    key: "curbsideCheckInTime",
    get: function get() {
      return this._curbsideCheckInTime;
    },
    set: function set(_curbsideCheckInTime) {
      var _this3 = this;

      runInAction(function () {
        _this3._curbsideCheckInTime = _curbsideCheckInTime;
      });
    }
  }]);

  return Curbside;
}(Base), (_descriptor = _applyDecoratedDescriptor(_class.prototype, "curbsideModel", [observable], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: function initializer() {
    return null;
  }
}), _descriptor2 = _applyDecoratedDescriptor(_class.prototype, "formState", [observable], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: function initializer() {
    return {
      submitCount: 0
    };
  }
}), _descriptor3 = _applyDecoratedDescriptor(_class.prototype, "_curbsideCheckInTime", [observable], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: function initializer() {
    return null;
  }
}), _applyDecoratedDescriptor(_class.prototype, "whenAppActive", [action], Object.getOwnPropertyDescriptor(_class.prototype, "whenAppActive"), _class.prototype), _applyDecoratedDescriptor(_class.prototype, "analyticsPayload", [computed], Object.getOwnPropertyDescriptor(_class.prototype, "analyticsPayload"), _class.prototype), _applyDecoratedDescriptor(_class.prototype, "analyticsPayloadWithGeoFenceData", [computed], Object.getOwnPropertyDescriptor(_class.prototype, "analyticsPayloadWithGeoFenceData"), _class.prototype), _applyDecoratedDescriptor(_class.prototype, "curbsideCheckInTime", [computed], Object.getOwnPropertyDescriptor(_class.prototype, "curbsideCheckInTime"), _class.prototype)), _class);
export { Curbside as default };